import React from 'react'
import styled from 'styled-components'
import media from '../../../utils/style'
import { rem } from 'polished'
import IconSpeedometer from '../../../vectors/IconSpeedometer'
import IconGearStick from '../../../vectors/IconGearStick'
import IconFuel from '../../../vectors/IconFuel'

const PanelContentWrapper = styled.div`
  position: relative;
  padding: 16px 16px 0;
`

const PanelDescription = styled.p`
  margin-bottom: 8px;
  line-height: 1.2;
`

const PanelOfferTitle = styled.div`
  font-size: 20px;
  line-height: 1.2;
  padding-bottom: 4px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.green};
`

const PanelOfferDescription = styled.div`
  font-size: 16px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.blue};
`

const PanelQuestions = styled.div`
  margin-bottom: 0;
  text-align: left;
  background-color: ${(props) => props.theme.colors.white};

  a {
    text-transform: none;
    color: ${(props) => props.theme.colors.blue};
    font-size: ${(props) => rem(props.theme.fontSizes[3])};
  }

  span {
    margin-bottom: 5px;
    vertical-align: bottom;
    display: inline-block;
  }
`

const PanelSmallText = styled.small`
  display: block;
  font-size: 13px;
  line-height: 1.2;
  margin-bottom: 16px;
  color: ${(props) => props.theme.colors.grey_light};
`

const PanelTag = styled.li`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  line-height: 18px;
  padding: 3px 8px;
  margin: 4px;
  border-radius: 4px;
  background-color: #e9e9ea;
  color: #3b3c41;

  svg {
    width: 13px;
    height: 13px;
  }
`

const PanelTagIcon = styled.span``

const PanelTagReg = styled(PanelTag)`
  background-color: #fdc630;
  font-weight: bold;
`

const PanelTagFeature = styled(PanelTag)`
  background-color: ${(props) => props.theme.colors.green};
  font-weight: bold;
  color: ${(props) => props.theme.colors.white};
  text-transform: uppercase;
`

const PanelTagList = styled.ul`
  margin: -4px;
  margin-bottom: 4px;
`

const PanelTitle = styled.h1`
  font-size: 20px;
  line-height: 1.333;
  margin-bottom: 8px;
  padding-right: 40px;
  ${media.LargeScreenUp`
    font-size: 24px;
  `};
`

const panelIconMap = {
  Year: '',
  Mileage: <IconSpeedometer />,
  Colour: '',
  Transmission: <IconGearStick />,
  Fuel: <IconFuel />
}

export {
  PanelContentWrapper,
  PanelDescription,
  PanelQuestions,
  PanelSmallText,
  PanelTag,
  PanelTagIcon,
  PanelTagReg,
  PanelTagFeature,
  PanelTagList,
  PanelTitle,
  panelIconMap,
  PanelOfferTitle,
  PanelOfferDescription
}
